module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Gas.18de7522.svg";